// HTML5 entities map: { name -> utf16string }
//
'use strict';

/*eslint quotes:0*/
module.exports = require('entities/maps/entities.json');



//////////////////
// WEBPACK FOOTER
// ./node_modules/markdown-it/lib/common/entities.js
// module id = 315
// module chunks = 0